export default "__VITE_ASSET__facb6cd7__"